module.controller('signupCtrl', ['$state', function($state) {

  var vm = this;

  vm.$state = $state;

}]);
